import { Setting } from '../../dataTypes/type-setting';

export class UrlVisibilityDeciderService {

    static checkButtonVisibility(privacyButtonsUrls: Setting.PrivacyButtonsUrls): boolean {

        // Check if any of the used keys are missing
        if (!privacyButtonsUrls.contains || !privacyButtonsUrls.isEqualTo ||
            !privacyButtonsUrls.startsWith || !privacyButtonsUrls.regEx
        ) {
            return true;
        }

        const url = location.href;
        if (
            (Array.isArray(privacyButtonsUrls.contains) && !privacyButtonsUrls.contains.length)
            && (Array.isArray(privacyButtonsUrls.isEqualTo) && !privacyButtonsUrls.isEqualTo.length)
            && (Array.isArray(privacyButtonsUrls.regEx) && !privacyButtonsUrls.regEx.length)
            && (Array.isArray(privacyButtonsUrls.startsWith) && !privacyButtonsUrls.startsWith.length)) {
            return true;
        }
        let keepButtonVisible = false;
        privacyButtonsUrls.contains.forEach(elem => {
            if (url.indexOf(elem) > -1) {
                keepButtonVisible = true;
            }
        });
        privacyButtonsUrls.isEqualTo.forEach(elem => {
            if (url === elem) {
                keepButtonVisible = true;
            }
        });
        privacyButtonsUrls.regEx.forEach(elem => {
            const regex = new RegExp(elem, 'g');
            if (regex.test(url)) {
                keepButtonVisible = true;
            }
        });
        privacyButtonsUrls.startsWith.forEach(elem => {
            const regex = new RegExp('^' + elem, 'g');
            if (regex.test(url)) {
                keepButtonVisible = true;
            }
        });
        return keepButtonVisible;
    }
}